export default [
  {
    id: "80",
    product: "Nikon P1000",
    price: "$699",
    status: "processing"
  },
  {
    id: "85",
    product: "Xbox One X",
    price: "$700",
    status: "sent"
  },
  {
    id: "102",
    product: "Microsoft surface Pro",
    price: "$2000",
    status: "in-transit"
  },
  {
    id: "128",
    product: "UPS",
    price: "$280",
    status: "processing"
  },
  {
    id: "180",
    product: "WD Extenal SSD",
    price: "$999",
    status: "delivered"
  }
];
